import { render, staticRenderFns } from "./NewProjectCard.vue?vue&type=template&id=76062d99&"
import script from "./NewProjectCard.vue?vue&type=script&lang=js&"
export * from "./NewProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports